export default __webpack_public_path__ + "locales/bg/Article.json?hash=dbf69508e6a083fdfeeeaaa843ea17c6";